import { Box, Button, Stack, theme } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { LargeProductSuitCardData } from '../types'
import { prismicImageLoader } from '@app/common/src/utils/prismicImageLoader'
import Image from 'next/image'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

const LargeProductSuitCard: FC<{ data?: LargeProductSuitCardData }> = ({ data }) => {
  if (!data) return null

  const isCreateFlowcodeBtn = data.button_label?.toLowerCase() === 'create a flowcode'
  const isImageRightAligned = data.image_alignment === 'Right'

  return (
    <Box
      sx={{
        paddingX: theme => theme.spacing(6)
      }}
    >
      <Stack
        direction={{
          xs: isImageRightAligned ? 'column' : 'column-reverse',
          lg: 'row'
        }}
        sx={{
          maxWidth: {
            xs: '544px',
            lg: '998px'
          },
          mx: 'auto'
        }}
      >
        <Box
          sx={{
            order: isImageRightAligned ? 2 : 1
          }}
        >
          {data.image?.url && (
            <Image
              src={data.image?.url}
              alt={data.image?.alt ?? ''}
              loader={prismicImageLoader}
              width={560}
              height={386}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
          )}
        </Box>
        <Stack
          direction={'column'}
          justifyContent="center"
          sx={{
            order: isImageRightAligned ? 1 : 2,
            maxWidth: {
              xs: '486px',
              lg: 'auto'
            },
            mx: 'auto',
            ml: {
              lg: isImageRightAligned ? 0 : '36px'
            },
            mr: {
              lg: isImageRightAligned ? '36px' : 0
            }
          }}
        >
          {data['logo-title']?.url && (
            <Box
              sx={{
                lg: {
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'left',
                  width: '100%'
                },
                pb: theme.spacing(4)
              }}
            >
              <Image
                src={data['logo-title']?.url}
                alt={data['logo-title']?.alt ?? 'logo'}
                loader={prismicImageLoader}
                width={data['logo-title']?.dimensions?.width}
                height={data['logo-title']?.dimensions?.height}
                style={{ maxWidth: '153px', objectFit: 'contain' }}
              />
            </Box>
          )}
          <Stack
            sx={{
              marginY: theme.spacing(4),
              textAlign: { xs: 'center', lg: 'left' }
            }}
            direction="column"
            alignItems={{
              xs: 'center',
              lg: 'start'
            }}
            spacing={theme.spacing(4)}
          >
            <PrismicText
              fontSize={theme.typography.headlineMedium.fontSize}
              richTextField={data.subheader}
              variant="display/large"
              lineHeight="40px"
            />
            <PrismicText richTextField={data.description} variant="body/large" />
            {data.button_label && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%'
                }}
              >
                <Button
                  href={isCreateFlowcodeBtn ? undefined : data.button_href?.url}
                  onClick={isCreateFlowcodeBtn ? () => window.scrollTo(0, 0) : undefined}
                  variant="contained"
                  fullWidth
                  aria-label={`${data.button_label} page`}
                >
                  {data.button_label}
                </Button>
              </Box>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}

export default LargeProductSuitCard
